import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { BoxForm, TextField } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { Schema } from 'features/globalSetup/features/amazon/forms/GeneralPageForm'
import { useAbility } from 'providers/casl'

export const AmazonUamTamSection = () => {
  const ability = useAbility()
  const { t } = useTranslation('features/globalSetup/amazon', {
    keyPrefix: 'pages.general.amazonUamTam',
  })

  const { control } = useFormContext<Schema>()

  const isDisabled: boolean = ability.cannot('update', 'GlobalSetupFeature-amazon')

  return (
    <Paper>
      <SectionHeader
        subtitle={t('subtitle')}
        title={t('title')}
      />

      <GapBox />

      <BoxForm>
        <TextField
          control={control}
          disabled={isDisabled}
          label={t('pubId.label')}
          name='pubId'
          placeholder={t('pubId.label')}
        />
      </BoxForm>
    </Paper>
  )
}
